export default "__VITE_ASSET__BxddKCMx__"